"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.workspaceInvariant = exports.backendInvariant = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2021 GoodData Corporation
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
function ambientInvariantFactory(itemName, providerName) {
    return function (item, contextName) {
        return ts_invariant_1.default(item, "The " + itemName + " in " + contextName + " must be defined. Either pass it as a config prop or make sure there is a " + providerName + " up the component tree.");
    };
}
exports.backendInvariant = ambientInvariantFactory("backend", "BackendProvider");
exports.workspaceInvariant = ambientInvariantFactory("workspace", "WorkspaceProvider");
//# sourceMappingURL=utils.js.map